import { registerPlugin } from '@capacitor/core';
import { IDevereIntercomPlugin } from './definitions';

const DevereCapacitorIntercom = registerPlugin<IDevereIntercomPlugin>('DevereCapacitorIntercom', {
    web: () => import('./web').then(m => new m.DevereIntercomWeb()),
});

export * from './definitions';
export { DevereCapacitorIntercom };